import { reactive } from 'vue'
import api from '@/api'

const DEFAULT_STATS = {
  species_count: null,
  cases_count: null,
  papers_count: null,
  genes_count: null,
  pesticides_count: null,
  monitoring_count: null,
  mechanism_count: null,
}

export const statsState = reactive({
  loading: false,
  loaded: false,
  data: { ...DEFAULT_STATS },
  error: null,
})

let statsRequest = null

export async function fetchStats({ force = false } = {}) {
  if (statsRequest) return statsRequest
  if (statsState.loaded && !force) return statsState.data

  statsState.loading = true
  statsRequest = api.get('/stats/')
    .then(response => {
      statsState.data = {
        ...statsState.data,
        ...response.data,
      }
      statsState.loaded = true
      statsState.error = null
      return statsState.data
    })
    .catch(error => {
      statsState.error = error
      console.error('Failed to load APRS statistics', error)
      return statsState.data
    })
    .finally(() => {
      statsState.loading = false
      statsRequest = null
    })

  return statsRequest
}

export function ensureStats() {
  return fetchStats()
}

export async function preloadStats(timeoutMs = 500) {
  const request = fetchStats()
  await Promise.race([
    request,
    new Promise(resolve => setTimeout(resolve, timeoutMs)),
  ])
}
